routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/signin', {
      template: require('./signin.html'),
      controller: 'SigninCtrl',
      controllerAs: 'signin',
      app: false,
      resolve: {
        currentUser: ['CurrentUser', '$q', '$route', '$window', '$location',
          (CurrentUser, $q, $route, $window, $location) => {
            var u = $q.defer();
            CurrentUser.api.fetch().then(user => {
              var redirectPath;
              if ($route.current.params.redirect) {
                redirectPath = $route.current.params.redirect;
              } else {
                redirectPath = $window.isFactWindow ?
                  '/fact' : '/home';
                if (user.lastCaseId) {
                  redirectPath += `/${user.lastCaseId}`;
                }
              }
              $location.url(redirectPath);
            }, () => {
              u.resolve();
            });
            return u.promise;
          }
        ],
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/signin/signin.routes.js